export const isEmptyObject = (obj): boolean => {
    for (const key in obj) {
        return false;
    }
    return true;
};
